import React, { useState } from 'react';
import Tabs, { TabPane } from 'components/Global/Tabs';
import RegularDataForm from './regular-data-form';

const UpdateDataForm = ({ customer, selectedCountry, imagePreviewHandler, getFileName, approvalUpdate }) => {
  const [activeTab, setActiveTab] = useState('Data Sekarang');

  const [
    oldOrderData,
    // setOldOrderData
  ] = useState({});
  const [
    newOrderData,
    // setNewOrderData
  ] = useState({});

  return (
    <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
      <TabPane label="Data Sekarang">
        <RegularDataForm
          approvalUpdate={approvalUpdate}
          customer={customer}
          data={newOrderData}
          getFileName={getFileName}
          imagePreviewHandler={imagePreviewHandler}
          selectedCountry={selectedCountry}
        />
      </TabPane>
      <TabPane label="Data Sebelum">
        <RegularDataForm
          approvalUpdate={approvalUpdate}
          customer={customer}
          data={oldOrderData}
          getFileName={getFileName}
          imagePreviewHandler={imagePreviewHandler}
          selectedCountry={selectedCountry}
        />
      </TabPane>
    </Tabs>
  );
};

export default UpdateDataForm;
